import { useEffect } from 'react';
import { pick, prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getURLParam } from '@core/js/utils/url.util';
import { useCookieSettingsSelector, useUserSelector } from '@core/js/store/hooks';
import { useCommonCookie } from './useCommonCookie';
import { useShowingMode } from './useShowingMode';

import { showCookiesRegulationPopupAction } from '../store/actions';
import { ROLE_MODE, SHOWING_MODE } from './../constants';

export const useCookiesRegulationPopup = () => {
    const dispatch = useDispatch();
    const role = useUserSelector(prop('role'));
    const { search } = useLocation();
    const hideByUrl = getURLParam(search, 'hideCookieLayer') === '1';
    const showingMode = useShowingMode();
    const commonCookie = useCommonCookie();
    const { isCommonCookieUpdated } = useCookieSettingsSelector(pick(['isCommonCookieUpdated']));

    useEffect(() => {
        const isHideMessage = hideByUrl
            || Number(commonCookie)
            || isCommonCookieUpdated
            || role === ROLE_MODE.ADMIN
            || !navigator.cookieEnabled
            || showingMode === SHOWING_MODE.HIDDEN;

        if (isHideMessage) {
            return;
        }

        dispatch(showCookiesRegulationPopupAction());
    }, [commonCookie, dispatch, hideByUrl, isCommonCookieUpdated, role, showingMode]);
};
